// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2WyVr","selects":"Documents_selects__2RhUL"};